import React, { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaHome, FaStore, FaTag, FaBell, FaUser } from 'react-icons/fa';
import { useNotifications } from '../contexts/NotificationContext';
import './MobileBottomNav.css';

const SLOTS = [
  {
    to: '/feed',
    label: 'Home',
    Icon: FaHome,
    match: (p) => p === '/feed' || p === '/',
  },
  {
    to: '/marketplace',
    label: 'Market',
    Icon: FaStore,
    match: (p, tab) => p.startsWith('/marketplace') && tab !== 'my-listings',
  },
  {
    to: '/marketplace?tab=my-listings',
    label: 'Sell',
    Icon: FaTag,
    match: (p, tab) => p.startsWith('/marketplace') && tab === 'my-listings',
  },
  {
    to: '/notifications',
    label: 'Activity',
    Icon: FaBell,
    match: (p) => p.startsWith('/notifications'),
    showBadge: true,
  },
  {
    to: '/profile',
    label: 'Profile',
    Icon: FaUser,
    match: (p) => p.startsWith('/profile'),
  },
];

const MobileBottomNav = () => {
  const location = useLocation();
  const { unreadCount } = useNotifications();

  useEffect(() => {
    document.body.classList.add('has-mobile-bottom-nav');
    return () => document.body.classList.remove('has-mobile-bottom-nav');
  }, []);

  // Hide the bottom nav while the on-screen keyboard is open. iOS / Android
  // Safari anchor position:fixed to the layout viewport, so `bottom: 0`
  // sits right above the keyboard and steals real estate from the input.
  // visualViewport.height shrinks by the keyboard height when it opens;
  // a >150px delta vs. window.innerHeight is reliably "keyboard up" and
  // bigger than any URL-bar collapse difference.
  useEffect(() => {
    if (typeof window === 'undefined' || !window.visualViewport) return;
    const vv = window.visualViewport;
    const onChange = () => {
      const keyboardOpen = window.innerHeight - vv.height > 150;
      document.body.classList.toggle('keyboard-open', keyboardOpen);
    };
    vv.addEventListener('resize', onChange);
    onChange();
    return () => {
      vv.removeEventListener('resize', onChange);
      document.body.classList.remove('keyboard-open');
    };
  }, []);

  const tab = new URLSearchParams(location.search).get('tab');

  return (
    <nav className="mobile-bottom-nav" aria-label="Primary">
      {SLOTS.map(({ to, label, Icon, match, showBadge }) => {
        const active = match(location.pathname, tab);
        const badgeCount = showBadge ? unreadCount : 0;
        return (
          <NavLink
            key={label}
            to={to}
            replace
            onClick={() => window.scrollTo(0, 0)}
            className={`mobile-bottom-nav__slot${active ? ' is-active' : ''}`}
            aria-current={active ? 'page' : undefined}
            aria-label={
              showBadge && badgeCount > 0
                ? `${label}, ${badgeCount} unread`
                : undefined
            }
          >
            <span className="mobile-bottom-nav__icon-wrap">
              <Icon className="mobile-bottom-nav__icon" aria-hidden="true" />
              {badgeCount > 0 && (
                <span className="notification-badge">
                  {badgeCount > 99 ? '99+' : badgeCount}
                </span>
              )}
            </span>
            <span className="mobile-bottom-nav__label">{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default MobileBottomNav;
